export enum LockStage {
  UPDATE_ESTIMATION_TABLE,
  ADD_TO_CHANNEL,
  UPDATE_BLACKLIST,
  UPDATE_PARAMETERS,
  SELL_COLLATERAL,
  MINT,
  UPDATE_ADMIN,
  NOTIFY_REWARD,
  BURN,
  ERASE_DEBT,
  CONFIRM_UPDATE_ESTIMATION_TABLE,
  CONFIRM_ADD_TO_CHANNEL,
  CONFIRM_UPDATE_BLACKLIST,
  CONFIRM_UPDATE_PARAMETERS,
  CONFIRM_SELL_COLLATERAL,
  CONFIRM_MINT,
  CONFIRM_UPDATE_ADMIN,
  CONFIRM_NOTIFY_REWARD,
  CONFIRM_BURN,
  CONFIRM_ERASE_DEBT,
  CONFIRM_WITHDRAW_TREASURY,
  SETTINGS,
  ADMIN_SETTINGS,
  TX_CONFIRMED,
}
